import React from "react"
import { withErrorBoundary } from "react-error-boundary"
import Image from "next/image"
import type { GenericImage, Maybe } from "types"
import { Logger } from "lib/logger"
import { SixteenNine } from "packages/ui-shared/components/SixteenNine"
import { cleanTitle } from "components/Contentful/RichTextRenderer/RichTextRenderer.utils"
import { ReadMore } from "../ReadMore"

import {
  errorContainer,
  outerContainer,
  markdownContainer,
  contentContainer,
  imageContainer,
  innerContainerVariants,
} from "./PLPHeader.css"

type Props = {
  image?: Maybe<GenericImage>
  title: string
  description: string
}

const PLPHeaderComponent: React.FC<Props> = ({ image, title, description }) => {
  return (
    <div className={outerContainer} data-test-id="PLPHeader">
      <div
        className={innerContainerVariants[image ? "WithImage" : "WithoutImage"]}
      >
        {image?.src && (
          <div className={imageContainer}>
            <SixteenNine>
              <Image
                src={image.src}
                alt={`${title.trim()} header image`}
                title={`${cleanTitle(title)}-header-image.jpg`}
                data-testid="PLPHeaderImage"
                unoptimized
                sizes="100vw"
                width={800}
                height={450}
              />
            </SixteenNine>
          </div>
        )}
        <div className={contentContainer}>
          <h1 id={cleanTitle(title)} data-testid="PLPTitle">
            {title.trim()}
          </h1>
          <div className={markdownContainer}>
            <ReadMore text={description} location="plp" />
          </div>
        </div>
      </div>
    </div>
  )
}

export const PLPHeader = withErrorBoundary(PLPHeaderComponent, {
  fallback: <div className={errorContainer} />,
  onError(error) {
    Logger.warn(`PLP header failed to load. ${error}`)
  },
})
